// extracted by mini-css-extract-plugin
module.exports = {"labelsWrapper":"ProductLabelsBase_labelsWrapper__2inmY","label":"ProductLabelsBase_label__1gw7B"};